var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React from 'react';
import ReactDOM from 'react-dom';
var Portal = /** @class */function (_super) {
  __extends(Portal, _super);
  function Portal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Portal.prototype.componentDidMount = function () {
    this.createContainer();
  };
  Portal.prototype.componentDidUpdate = function (prevProps) {
    var didUpdate = this.props.didUpdate;
    if (didUpdate) {
      didUpdate(prevProps);
    }
  };
  Portal.prototype.componentWillUnmount = function () {
    this.removeContainer();
  };
  Portal.prototype.createContainer = function () {
    this.container = this.props.getContainer ? this.props.getContainer() : Portal.getContainer();
    this.forceUpdate();
  };
  Portal.prototype.removeContainer = function () {
    if (this.container && this.container.parentNode) {
      try {
        this.container.parentNode.removeChild(this.container);
      } catch (e) {}
    }
  };
  Portal.prototype.render = function () {
    if (this.container) {
      return /*#__PURE__*/ReactDOM.createPortal(this.props.children, this.container);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  Portal.getContainer = function () {
    var element = document.createElement('div');
    element.style.position = 'absolute';
    element.style.top = '0';
    element.style.left = '0';
    element.style.width = '100%';
    window.document.body.appendChild(element);
    return element;
  };
  return Portal;
}(React.Component);
export default Portal;